import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  /** dailyCents / lifetimeCents 二选一传非空。 */
  onSubmit: (dailyCents: number | null, lifetimeCents: number | null) => void;
}

export default function BatchBudgetDialog({ open, onOpenChange, count, onSubmit }: Props) {
  const [mode, setMode] = useState<"daily" | "lifetime">("daily");
  const [amount, setAmount] = useState("");

  const submit = () => {
    const n = Number(amount);
    if (!Number.isFinite(n) || n <= 0) return;
    const cents = Math.round(n * 100);
    if (mode === "daily") onSubmit(cents, null);
    else onSubmit(null, cents);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>批量修改预算</DialogTitle>
          <DialogDescription>
            将对选中的 {count} 项设置同一个预算值。日预算与总预算只能选其一（Meta 平台限制）。
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <div className="flex gap-2 text-sm">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                checked={mode === "daily"}
                onChange={() => setMode("daily")}
              />
              日预算
            </label>
            <label className="flex items-center gap-1">
              <input
                type="radio"
                checked={mode === "lifetime"}
                onChange={() => setMode("lifetime")}
              />
              总预算
            </label>
          </div>
          <div>
            <label className="text-sm text-muted-foreground">金额（单位与账户币种一致，如 USD）</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder={mode === "daily" ? "如 10 表示每日 10" : "如 500 表示总额 500"}
              className="mt-1 w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>取消</Button>
          <Button onClick={submit} disabled={!amount || Number(amount) <= 0}>
            确定
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
